import React from "react";

const FlagLight: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="29"
    viewBox="0 0 27 30"
    fill="none"
    {...props}
  >
    <path
      d="M1.875 0.9375C1.875 0.421875 1.45312 0 0.9375 0C0.421875 0 0 0.421875 0 0.9375V29.0625C0 29.5781 0.421875 30 0.9375 30C1.45312 30 1.875 29.5781 1.875 29.0625V22.9688L7.51758 21.5566C9.92578 20.9531 12.4746 21.2344 14.6953 22.3418C17.2852 23.6367 20.291 23.7949 22.998 22.7754L25.0312 22.0137C25.7637 21.7383 26.25 21.041 26.25 20.2559V3.86719C26.25 2.51953 24.832 1.64063 23.625 2.24414L23.0625 2.52539C20.3496 3.88477 17.1562 3.88477 14.4434 2.52539C12.3867 1.49414 10.0254 1.23633 7.79297 1.79297L1.875 3.28125V0.9375ZM1.875 5.21484L8.24414 3.62109C10.043 3.16992 11.9414 3.38086 13.5996 4.20703C16.8398 5.83008 20.6543 5.83008 23.9004 4.20703L24.375 3.9668V20.2559L22.3418 21.0176C20.1211 21.8496 17.6543 21.7207 15.5332 20.6602C12.9141 19.3477 9.9082 19.0195 7.06641 19.7285L1.875 21.0352V5.21484Z"
      fill="white"
    />
  </svg>
);

export default FlagLight;
